'use client';

import { useEffect, useState } from 'react';
import { InviteCodeDialog } from '@/components/InviteCodeDialog';
import { authBus } from '@/lib/auth-bus';

export function InviteCodeRequiredDialog() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleInviteCodeRequired = () => setOpen(true);
    authBus.onInviteCodeRequired(handleInviteCodeRequired);
    return () => authBus.offInviteCodeRequired(handleInviteCodeRequired);
  }, []);

  return (
    <InviteCodeDialog
      open={open}
      onOpenChange={setOpen}
    />
  );
}
